import { FC } from 'react';

import { useI18n } from '#hooks/useI18n';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Flex, Semibold } from '@zazume/zzm-base';

import { Document } from '#/models';

import { Expiration } from './components/Expiration';
import { FileSize } from './components/FileSize';
import { FileType } from './components/FileType';
import { InvoiceStatusModalInfo } from './components/InvoiceStatusModalInfo';
import { Metadata } from './components/Metadata';
import { OwnerVisibility } from './components/OwnerVisibility';
import { SignaturesModalInfo } from './components/SignaturesModalInfo';

const Container = styled.div(
  ({ theme }) => css`
    width: 100%;

    ${theme.mq.sm} {
      width: 12.75rem;
    }
  `
);

interface DocumentModalInfoProps {
  document: Document;
  onSendReminder?: () => Promise<void>;
  onAfterUpdate?: () => Promise<void>;
}

export const DocumentModalInfo: FC<DocumentModalInfoProps> = ({ document, onSendReminder, onAfterUpdate }) => {
  const { t } = useI18n();
  const { size, expireAt, type, isHiddenFromOwner } = document;

  const isInvoice = ['invoice', 'creditNoteInvoice'].includes(type);

  return (
    <Container>
      <Flex direction="column" gap="s8">
        <Semibold variant="M">{t('general.information')}</Semibold>
        <Expiration expireAt={expireAt} />
        <FileSize fileSize={size} />
        <FileType type={type} />
        <OwnerVisibility isHiddenFromOwner={isHiddenFromOwner} />
        <Metadata metadata={document.metadata} />
        <SignaturesModalInfo document={document} onSendReminder={onSendReminder} onAfterUpdate={onAfterUpdate} />
        {isInvoice && <InvoiceStatusModalInfo documentId={document._id} />}
      </Flex>
    </Container>
  );
};
